import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { firebaseConfig } from './credential';
import { CreagaraPage } from './creagara/creagara.page';
import { StartgaraPage } from './startgara/startgara.page';
import { LoginPage } from './login/login.page';
import { RegistrazionePage } from './registrazione/registrazione.page';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreaseriePage } from './creaserie/creaserie.page';
import { DBMeter } from '@ionic-native/db-meter/ngx';

import { AngularFireAuthModule } from '@angular/fire/auth';

import * as firebase from 'firebase';
import { AuthenticateService } from './services/authentication.service';
import { AuthGuard } from './core/auth.guard';

firebase.initializeApp(firebaseConfig);
import { IonicStorageModule } from '@ionic/storage';
import { SelectuserPage } from './selectuser/selectuser.page';
import { AddTiratorePage } from './addtiratore/addtiratore.page';
import { GeneraslotPage } from './generaslot/generaslot.page';
import { CreautenteesternoPage } from './creautenteesterno/creautenteesterno.page';

@NgModule({
  declarations: [AppComponent,CreagaraPage,CreaseriePage,SelectuserPage,AddTiratorePage,GeneraslotPage,CreautenteesternoPage],
  entryComponents: [CreagaraPage,CreaseriePage,SelectuserPage,AddTiratorePage,GeneraslotPage,CreautenteesternoPage],
  imports: [
    // CreagaraPage,CreaseriePage,SelectuserPage,AddTiratorePage,GeneraslotPage,
    FormsModule,
    BrowserModule,
    IonicModule.forRoot({
      rippleEffect: false,
      mode: 'md'
    }),
    AppRoutingModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFirestoreModule,
    AngularFireAuthModule,
    IonicStorageModule.forRoot() 
  ],
  providers: [
    StatusBar,
    SplashScreen,
    DBMeter,
    AuthenticateService,
    AuthGuard,
    Storage,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
